// extracted by mini-css-extract-plugin
export default {"pageContent":"LandingPage_pageContent__HJa42","firstScreen":"LandingPage_firstScreen__ZD82v","spin":"LandingPage_spin__SeX2n"};